import dynamic from 'next/dynamic'

export const ImageCard = dynamic(() => import('./image-card'))
